export default __webpack_public_path__ + "static/media/line.9da6a10e.svg";